import type { ReactNode } from 'react';
import './MobHeader.css';

interface MobHeaderProps {
  title: string;
  subtitle?: string;
  showPropertyChevron?: boolean;
  onPropertyClick?: () => void;
  right?: ReactNode;
}

export function MobHeader({
  title,
  subtitle,
  showPropertyChevron = false,
  onPropertyClick,
  right,
}: MobHeaderProps) {
  const titleNode = (
    <>
      <span className="mob-header__title">{title}</span>
      {showPropertyChevron ? <span className="mob-header__chev">▼</span> : null}
    </>
  );

  return (
    <header className="mob-header">
      <div className="mob-header__block">
        {showPropertyChevron && onPropertyClick ? (
          <button
            type="button"
            className="mob-header__title-btn"
            onClick={onPropertyClick}
          >
            {titleNode}
          </button>
        ) : (
          <div>{titleNode}</div>
        )}
        {subtitle ? <div className="mob-header__sub">{subtitle}</div> : null}
      </div>
      <div className="mob-header__spacer" />
      {right}
    </header>
  );
}
